// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__1ecs9","label":"Section_label__1P5IG","contentWrap":"Section_contentWrap__CRa_G","footer":"Section_footer__2AKS-","footerInner":"Section_footerInner__u25Fd"};